module.exports = "/_next/static/images/article-f079b266063942dc4aba5aa2444f8011.svg";